import React from 'react';
import { Route } from 'react-router-dom';
import RouteMenu from 'mrf/view/MenuRoute';
import path from 'path';
import PublicKeyList from './PublicKeyList';
import PublicKeyForm from './PublicKeyForm';


export default function PublicKey({ match }) {
    return (
        <RouteMenu match={match} indexComponent={PublicKeyList}>
            <Route path={path.join(match.url, 'new')} component={PublicKeyForm} />
            <Route path={path.join(match.url, 'edit/:id')} component={PublicKeyForm} />
        </RouteMenu>
    );
}